import { useCurrentUser } from 'api';
import { useTranslation } from 'i18n';
import { Box, Typography } from 'ui';

export const AdminAiVersionTitle = ({ title, version }: { title: string; version?: string }) => {
  const { t } = useTranslation('features');
  const { data: currentUser } = useCurrentUser();

  return (
    <Box component="span" sx={{ alignItems: 'center', display: 'inline-flex', gap: 1 }}>
      <Box component="span">{title}</Box>
      {currentUser?.is_superuser && version ? (
        <Typography component="span" variant="caption" color="secondary" noWrap>
          {t('breakdowns.adminAiVersionTitle.value', { values: { version } })}
        </Typography>
      ) : null}
    </Box>
  );
};
